export type ShareResult = 'shared' | 'copied' | 'unavailable' | 'failed' | 'aborted';

export const SHARE_FEEDBACK_LABEL: Record<Exclude<ShareResult, 'aborted'>, string> = {
  shared: 'Partagé',
  copied: 'Lien copié',
  unavailable: 'Partage indisponible',
  failed: 'Échec du partage',
};

/** URL absolue dans l’app (respecte `import.meta.env.BASE_URL`). */
export function buildAppUrl(path: string): string {
  const base = import.meta.env.BASE_URL || '/';
  const normalizedBase = base.endsWith('/') ? base : `${base}/`;
  const normalizedPath = path.replace(/^\//, '');
  if (typeof window === 'undefined') {
    return `${normalizedBase}${normalizedPath}`;
  }
  return new URL(normalizedPath, `${window.location.origin}${normalizedBase}`).toString();
}

export function buildMatchShareUrl(matchRouteId: string): string {
  return buildAppUrl(`match/${encodeURIComponent(matchRouteId.trim())}`);
}

export function buildObservationShareUrl(observationId: string, matchRouteId?: string): string {
  const params = new URLSearchParams({ id: observationId.trim() });
  const match = matchRouteId?.trim();
  if (match) params.set('match', match);
  return buildAppUrl(`observation/detailed?${params.toString()}`);
}

export async function shareContent(opts: {
  title: string;
  text: string;
  url: string;
}): Promise<ShareResult> {
  const nav =
    typeof navigator !== 'undefined'
      ? (navigator as Navigator & { share?: (data: ShareData) => Promise<void> })
      : null;
  const clipboardText = `${opts.text}\n${opts.url}`;
  try {
    if (nav?.share) {
      await nav.share({ title: opts.title, text: opts.text, url: opts.url });
      return 'shared';
    }
    if (nav?.clipboard?.writeText) {
      await nav.clipboard.writeText(clipboardText);
      return 'copied';
    }
    return 'unavailable';
  } catch (err) {
    if (err instanceof Error && err.name === 'AbortError') return 'aborted';
    return 'failed';
  }
}

export function shareResultToFeedback(result: ShareResult): string | null {
  if (result === 'aborted') return null;
  return SHARE_FEEDBACK_LABEL[result];
}
